/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/social-export-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { ListByPlatformUploadStatusQueryResponse, ListByPlatformUploadStatusPathParams } from "../models/ListByPlatformUploadStatus";

export function getListByPlatformUploadStatusUrl(platform: ListByPlatformUploadStatusPathParams["platform"]) {
  const res = { method: 'GET', url: `/upload/status/all/${platform}` as const }
  return res
}

/**
 * @summary Get uploads status
 * {@link /upload/status/all/:platform}
 */
export async function listByPlatformUploadStatus(platform: ListByPlatformUploadStatusPathParams["platform"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListByPlatformUploadStatusQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getListByPlatformUploadStatusUrl(platform).url.toString(), ... requestConfig })
  return res.data
}